import styled from 'styled-components';

export const ShareReview = styled.p`
  font-size: 16px;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 20px;
  font-style: norma;
  font-weight: 600;
`;
